import { useEffect, useMemo, useRef, useState } from 'react';

import { Empty2 } from '@/components/icon';
import { AiMusicReq, ResourceHistory, UrlInfo } from '@/interface/aigc';

import styles from './index.module.less';
import MusicHistoryItem from './item';

export interface IAigcMusicHistoryProps {
  histories: ResourceHistory[];
  pagination: {
    page: number;
    size: number;
    total: number;
  };
  loading: boolean;
  generateMusic: (postData: AiMusicReq) => void;
  getSrc: (src: UrlInfo) => void;
  onDelete: (id: string) => void;
}

const AigcMusicHistory: React.FC<IAigcMusicHistoryProps> = (props) => {
  const { histories = [], pagination, loading, generateMusic, getSrc, onDelete } = props;
  const [selectedMusic, setSelectedMusic] = useState<string>('initUrl');
  const latestItemRef = useRef<HTMLDivElement>(null);
  const historyLen = useRef<number>(histories.length);

  useEffect(() => {
    if (historyLen.current > 1 && histories.length > historyLen.current) {
      latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    historyLen.current = histories.length;
  }, [histories.length]);

  useEffect(() => {
    latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [pagination.page]);

  const handleSelect = (url: UrlInfo) => {
    if (!url.url) return;
    setSelectedMusic(url.url);
    getSrc(url);
  };

  const contentDom = useMemo(() => {
    if (loading) return null;
    return histories.length === 0
      ? (
        <div className={styles.placeholder}>
          <Empty2 />
          <div>暂未生成素材</div>
        </div>
      ) : (
        <div className={styles.history}>
          {histories.map((e, index) => (
            <div key={e.relateId || index} ref={index === 0 ? latestItemRef : null}>
              <MusicHistoryItem
                key={e.relateId || index}
                history={e}
                selectedMusic={selectedMusic}
                generateMusic={generateMusic}
                handleSelect={handleSelect}
                onDelete={onDelete}
              />
            </div>
          ))}
        </div>
      );
  }, [histories, loading, selectedMusic, generateMusic, handleSelect, onDelete]);

  return (
    <div className={styles.container}>
      {contentDom}
    </div>
  );
};

export default AigcMusicHistory;
